import type {
  LexicalBlockNode,
  LexicalNode,
  RichTextContent,
} from '@travelwin/cms/types';

export const isRichText = (content: unknown): content is RichTextContent => {
  return (
    typeof content === 'object' &&
    content !== null &&
    'root' in content &&
    typeof content.root === 'object' &&
    content.root !== null &&
    'children' in content.root &&
    Array.isArray(content.root.children)
  );
};

export const isLexicalBlockNode = (
  node: LexicalNode,
): node is LexicalBlockNode => {
  return (
    node.type === 'block' ||
    (node.type === 'inlineBlock' &&
      'fields' in node &&
      typeof node.fields === 'object' &&
      node.fields !== null &&
      'blockType' in node.fields &&
      typeof node.fields.blockType === 'string')
  );
};

export const traverseLexicalNodes = (
  node: LexicalNode,
  callback: (node: LexicalNode) => void,
) => {
  callback(node);

  if (!node.children) {
    return;
  }

  for (const child of node.children) {
    traverseLexicalNodes(child, callback);
  }
};

const isNodeEmpty = (node: LexicalNode): boolean => {
  const { children } = node;

  if (!Array.isArray(children) || children.length === 0) {
    return true;
  }

  return children.every((child) => {
    if ('text' in child && typeof child.text === 'string') {
      return child.text.trim() === '';
    }

    return isNodeEmpty(child);
  });
};

export const isRichTextEmpty = (
  richText: RichTextContent | undefined | null,
) => {
  const children = richText?.root.children;

  if (!Array.isArray(children) || children.length === 0) {
    return true;
  }

  return children.every((node) => isNodeEmpty(node));
};
